module.exports = __webpack_public_path__ + "static/dummy_klein-ed0192be0a8b739555179fd59ec67fc9.png";